import { isWeb } from "./runtimeEnvironment"

export function getWindow() {
  return isWeb() ? window : null
}
